<br>
<div>
  <div>
    <h4>Zip Code to Day Assignments</h4>
  </div>
</div>
<br>
@if (employee && employeeIsRM) {
<div>
  <div class="p-grid">
    <div class="p-col-2">
      <h6>Sunday</h6>
      <p-button icon="pi pi-plus" label="Add New Time Slot" (click)="addNewTimeSlot(0)"></p-button>
    </div>
    @for (timeSlot of sundayTimeSlots; track timeSlot) {
    <div class="p-col-10" [ngClass]="{'p-offset-2': timeSlot != sundayTimeSlots[0]}">
      <app-day-zip-code-item [zipCodeAssignments]="employee.zipCodeAssignments" [timeSlot]="timeSlot"
        (deletedItem)="handleDeletedItem(timeSlot, sundayTimeSlots)"></app-day-zip-code-item>
    </div>
    }
  </div>
  <div class="p-grid">
    <div class="p-col-2">
      <h6>Monday</h6>
      <p-button icon="pi pi-plus" label="Add New Time Slot" (click)="addNewTimeSlot(1)"></p-button>
    </div>
    @for (timeSlot of mondayTimeSlots; track timeSlot) {
    <div class="p-col-10" [ngClass]="{'p-offset-2': timeSlot != mondayTimeSlots[0]}">
      <app-day-zip-code-item [zipCodeAssignments]="employee.zipCodeAssignments" [timeSlot]="timeSlot"
        (deletedItem)="handleDeletedItem(timeSlot, mondayTimeSlots)"></app-day-zip-code-item>
    </div>
    }
  </div>
  <div class="p-grid">
    <div class="p-col-2">
      <h6>Tuesday</h6>
      <p-button icon="pi pi-plus" label="Add New Time Slot" (click)="addNewTimeSlot(2)"></p-button>
    </div>
    @for (timeSlot of tuesdayTimeSlots; track timeSlot) {
    <div class="p-col-10" [ngClass]="{'p-offset-2': timeSlot != tuesdayTimeSlots[0]}">
      <app-day-zip-code-item [zipCodeAssignments]="employee.zipCodeAssignments" [timeSlot]="timeSlot"
        (deletedItem)="handleDeletedItem(timeSlot, tuesdayTimeSlots)"></app-day-zip-code-item>
    </div>
    }
  </div>
  <div class="p-grid">
    <div class="p-col-2">
      <h6>Wednesday</h6>
      <p-button icon="pi pi-plus" label="Add New Time Slot" (click)="addNewTimeSlot(3)"></p-button>
    </div>
    @for (timeSlot of wednesdayTimeSlots; track timeSlot) {
    <div class="p-col-10" [ngClass]="{'p-offset-2': timeSlot != wednesdayTimeSlots[0]}">
      <app-day-zip-code-item [zipCodeAssignments]="employee.zipCodeAssignments" [timeSlot]="timeSlot"
        (deletedItem)="handleDeletedItem(timeSlot, wednesdayTimeSlots)"></app-day-zip-code-item>
    </div>
    }
  </div>
  <div class="p-grid">
    <div class="p-col-2">
      <h6>Thursday</h6>
      <p-button icon="pi pi-plus" label="Add New Time Slot" (click)="addNewTimeSlot(4)"></p-button>
    </div>
    @for (timeSlot of thursdayTimeSlots; track timeSlot) {
    <div class="p-col-10" [ngClass]="{'p-offset-2': timeSlot != thursdayTimeSlots[0]}">
      <app-day-zip-code-item [zipCodeAssignments]="employee.zipCodeAssignments" [timeSlot]="timeSlot"
        (deletedItem)="handleDeletedItem(timeSlot, thursdayTimeSlots)"></app-day-zip-code-item>
    </div>
    }
  </div>
  <div class="p-grid">
    <div class="p-col-2">
      <h6>Friday</h6>
      <p-button icon="pi pi-plus" label="Add New Time Slot" (click)="addNewTimeSlot(5)"></p-button>
    </div>
    @for (timeSlot of fridayTimeSlots; track timeSlot) {
    <div class="p-col-10" [ngClass]="{'p-offset-2': timeSlot != fridayTimeSlots[0]}">
      <app-day-zip-code-item [zipCodeAssignments]="employee.zipCodeAssignments" [timeSlot]="timeSlot"
        (deletedItem)="handleDeletedItem(timeSlot, fridayTimeSlots)"></app-day-zip-code-item>
    </div>
    }
  </div>
  <div class="p-grid">
    <div class="p-col-2">
      <h6>Saturday</h6>
      <p-button icon="pi pi-plus" label="Add New Time Slot" (click)="addNewTimeSlot(6)"></p-button>
    </div>
    @for (timeSlot of saturdayTimeSlots; track timeSlot) {
    <div class="p-col-10" [ngClass]="{'p-offset-2': timeSlot != saturdayTimeSlots[0]}">
      <app-day-zip-code-item [zipCodeAssignments]="employee.zipCodeAssignments" [timeSlot]="timeSlot"
        (deletedItem)="handleDeletedItem(timeSlot, saturdayTimeSlots)"></app-day-zip-code-item>
    </div>
    }
  </div>
</div>
}


@if (employee && !employeeIsRM) {
<div>
  Not a Regional Manager
</div>
}